module.exports = __webpack_public_path__ + "static/media/482.c14be448.pdf";